import { inject, Injectable } from '@angular/core';

import { EncripterService } from './encriptor.service';

@Injectable({ providedIn: 'root' })
export abstract class LocalStorageService {
  protected readonly encriptor = inject(EncripterService);

  constructor() {}

  setKey = (key: string, value: string) => {
    localStorage.setItem(key, this.encriptor.set(null, value));
  };

  getKey = (key: string) => {
    const value = localStorage.getItem(key);
    return value ? this.encriptor.get(null, value) : null;
  };
}
